import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './styles.scss';

export default function SkeletonLoading({ width, height, className }) {
  const skeletonLoadingClassName = classnames('skeleton-loading', className);

  return <div className={skeletonLoadingClassName} style={{ height, width }} />;
}

SkeletonLoading.propTypes = {
  className: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
};
